// Official Bekaert logo (docs/branding/logos, copied unmodified to
// public/logo/). The brand guidelines forbid recreating or recolouring the
// logo (p.15, p.19), so the theme swaps between the two official files: the
// positive version (cyan symbol + black word mark) on light surfaces and the
// negative (white) version on dark ones, via the --logo-*-display tokens.
// One role="img" wrapper keeps a single accessible name in either theme.

const LOGO_HEIGHT = { sm: "h-5", md: "h-6", lg: "h-8" } as const;

type LogoSize = keyof typeof LOGO_HEIGHT;

export function BrandLogo({ size = "md" }: { size?: LogoSize }) {
  const cls = `${LOGO_HEIGHT[size]} w-auto`;
  return (
    <span role="img" aria-label="Bekaert" className="inline-flex shrink-0">
      <img src="/logo/bekaert-logo.svg" alt="" className={`bk-logo-positive ${cls}`} />
      <img src="/logo/bekaert-logo-white.svg" alt="" className={`bk-logo-negative ${cls}`} />
    </span>
  );
}

// Logo + product name. The name sits behind a hairline divider with at least
// the 2c clear space the guidelines require around the logo (c = the symbol's
// stroke width, about a fifth of the logo height), so it never reads as a
// tagline attached to the logo (p.19, rule 3).
export function BrandLockup({ size = "md" }: { size?: LogoSize }) {
  return (
    <div className={`flex select-none items-center ${size === "lg" ? "gap-4" : "gap-3"}`}>
      <BrandLogo size={size} />
      <span aria-hidden="true" className={`${LOGO_HEIGHT[size]} w-px bg-[var(--border-strong)]`} />
      {/* .type-* sets its own weight outside Tailwind's layer, so Medium is inline. */}
      <span
        className={`${size === "lg" ? "type-h3" : "type-body"} leading-none text-[var(--text-secondary)]`}
        style={{ fontWeight: 500 }}
      >
        Knowledge
      </span>
    </div>
  );
}

export function BrandSymbol() {
  return <img src="/logo/bekaert-symbol.svg" alt="Bekaert" className="h-6 w-auto select-none" />;
}
